import React, {ChangeEvent} from "react";
import "./SignerName.scss"
import {Input} from "../../ui-components/Input/Input";

interface SignerNameProps {
    signerName: string;
    onSetSignerName: (signatureName: string) => void;
}


export const SignerName: React.FunctionComponent<SignerNameProps> = (props) => {
    const onChange = (event: ChangeEvent) => {
        const value = (event.target as HTMLInputElement).value;
        props.onSetSignerName(value);
    }

    return <div className="signature-name-input">
        <Input isValid={!props.signerName} type='text' required={true} value={props.signerName}
               onChange={onChange}/>
    </div>
}
